import { render, staticRenderFns } from "./orderStampConfigDialog.vue?vue&type=template&id=2af5fcaa&"
import script from "./orderStampConfigDialog.vue?vue&type=script&lang=js&"
export * from "./orderStampConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports